<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import Topbar from "@/components/topbar";
// import SideBar from "@/components/side-bar";
// import Rightsidebar from "@/components/right-sidebar";
// import Footer from "@/components/footer";
import moment from "moment";
import SideBarV2 from "../../components/side-bar-v2.vue";

export default {
  components: { SideBarV2, Topbar },
  data() {
    return {
      isMenuCondensed: false,
      openSideBar: false,
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.setAttribute("data-sidebar", "dark");
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    getTodayYear() {
      return moment.now().format("YYYY");
    },
    handleMenuClick() {
      if (!this.openSideBar) {
        this.openSideBar = true;
        document.body.addEventListener("click", this.closeSideBar);
      }
    },
    stopPropagation(e) {
      e.stopPropagation();
    },
    closeSideBar() {
      this.openSideBar = false;
      document.body.removeEventListener("click", this.closeSideBar);
    },
  },
  mounted() {
    document.body.classList.remove("auth-body-bg");
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<!-- <template>
  <div class="container-fluid">
    <div class="row border border-primary">
      <div class="border border-danger">one</div>
      <div class="border border-danger">two</div>
    </div>
  </div>
</template> -->

<template>
  <div class="">
    <div id="preloader">
      <div id="status">
        <div class="spinner">
          <i class="ri-loader-line spin-icon"></i>
        </div>
      </div>
    </div>

    <!-- Begin page -->
    <!-- <div class="container-fluid"> -->
    <div
      id="layout-wrapper"
      class="d-flex"
      style="
        background-color: rgb(246, 246, 243);
        height: 100vh;
        overflow: hidden;
      "
    >
      <div class="w-2 d-none d-lg-block">
        <SideBarV2 />
      </div>
      <div
        :style="{
          position: 'absolute',
          zIndex: '10000',
          background: 'rgba(0, 0, 0, 0.5)',
          transition: 'opacity 0.5s, visibility 0.2s, left 0.2s ease',
          opacity: openSideBar ? '1' : '0',
          visibility: openSideBar ? 'visible' : 'hidden',
          left: openSideBar ? '0' : '-0px',
          width: '100vw',
          height: '100vh',
        }"
        @click="handleMenuClick"
      >
        <div
          ref="mb_sidebar"
          style="position: relative; transition: left 0.2s ease; width: 280px"
          :style="{ left: openSideBar ? '0px' : '-280px' }"
          @click="stopPropagation"
        >
          <SideBarV2 />
        </div>
        <div style="position: absolute; left: 290px; top: 0px" ref="close">
          <span style="color: white; font-size: 40px"> &times; </span>
        </div>
      </div>
      <!-- <SideBar
        :is-condensed="isMenuCondensed"
        :type="leftSidebarType"
        :width="layoutWidth"
      /> -->
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="d-block d-lg-none">
        <Topbar @handleMenuClick="handleMenuClick()" />
      </div>
      <div
        class="main-container shadow-lg m-2"
        style="flex-grow: 1; flex-wrap: wrap; height: 100%; overflow: auto"
      >
        <!-- <div
          class="d-block d-lg-none border border-danger"
          style="height: 200px; margin-bottom: 25px"
        >
          <button>
            <i class="fa fa-bars"></i>
          </button>
        </div> -->
        <div class="">
          <div class="">
            <div class="container-fluid">
              <slot />
            </div>
          </div>
        </div>
        <!-- <Footer /> -->
      </div>
      <!-- <Rightsidebar /> -->
    </div>
    <!-- </div> -->
  </div>
</template>

<style>
.main-container {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background-color: white;
  padding-top: 5px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 10px !important;
}
@media (max-width: 992px) {
  .main-container {
    border-radius: 0px !important;
    margin: 0px !important;
    margin-top: 70px !important;
  }
}
.main-container::-webkit-scrollbar-thumb {
  background-color: rgb(171, 171, 171);
  border-radius: 4px;
}
.main-container::-webkit-scrollbar-track {
  background-color: rgb(241, 241, 241);
}
.main-container::-webkit-scrollbar {
  width: 5px;
  height: 20px;
}
table {
  border-radius: 10px !important;
}
th {
  text-align: left;
  color: black;
}
td {
  vertical-align: middle !important;
  padding-inline: 10px !important;
  text-align: left !important;
}
p {
  margin-bottom: 0px !important;
}

/* styles for date-picker */

.mx-table-date th {
  text-align: center !important;
}
.mx-table-date td {
  text-align: right !important;
}
.mx-week-number {
  color: red !important;
}
</style>
